// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__pJYJ7","pulse":"styles_pulse__SX4tT"};